//PASO 1
export const tiposCompania = [
    {value: 'vehicular', label: 'Vehicular', description:'(Financian vehículos: autos, motocicletas, camiones)'},
    {value: 'electrodomesticos', label: 'Electrodomésticos', description:'(Venta y financiamiento de electrodomésticos)'},
    {value: 'prestamos_personales', label: 'Préstamos Personales', description:'(Créditos personales sin garantía específica)'},
    {value: 'inmuebles', label: 'Inmuebles', description:'(Financian bienes raíces)'},
    {value: 'prestamos_negocios', label: 'Préstamos a Negocios', description:'(Créditos para capital de trabajo o expansión empresarial)'},
  ]

export const monedas = [
    { value: 'DOP', label: 'DOP - Peso Dominicano' },
    { value: 'USD', label: 'USD - Dólar Estadounidense' },
 ];

export const paises = [
    { value: 'RD', label: 'República Dominicana' },
    { value: 'US', label: 'Estados Unidos' },
]


//PASO 2
export const listaModulos = [
    {
      categoria: 'Gestión Comercial',
      modulos: [
        { key: 'ventas_generales', label: 'Ventas generales (detalle)', default: true, companytypes:[]},
        { key: 'prestamos', label: 'Prestamos', default: true, companytypes:[]},
        { key: 'inversionistas', label: 'Inversionistas', default: false, companytypes:[]},
        { key: 'iniciales', label: 'Inciales', default: false, companytypes:[]},
        { key: 'traspasos', label: 'Traspasos', default: false , companytypes:['vehicular','inmuebles']},
        { key: 'cargos', label: 'Cargos', default: false , companytypes:['vehicular','inmuebles']},
        { key: 'portafolio', label: 'Portafolio', default: false , companytypes:['vehicular','inmuebles']},
        { key: 'recuperaciones', label: 'Recuperaciones', default: false , companytypes:['vehicular','inmuebles','prestamos_negocios']},
        { key: 'productos_financieros', label: 'Productos financieros', default: true , companytypes:[]},

      ]
    },
    {
      categoria: 'Logística y Almacén',
      modulos: [
        { key: 'compras', label: 'Compras', default: false , companytypes:['vehicular','electrodomesticos','inmuebles']},
        { key: 'transferencias', label: 'Transferencias de mercancia', default: false, companytypes:['vehicular','electrodomesticos','inmuebles'] },
        { key: 'taller', label: 'Taller / servicios técnicos', default: false, companytypes:['vehicular','electrodomesticos'] },
        { key: 'productos_catalogo', label: 'Catálogo de productos', default: false , companytypes:['vehicular','electrodomesticos','inmuebles']},
      ]
    },
//    {
  //    categoria: 'Gestión Legal y Recuperación',
    //  modulos: [
      //  { key: 'incautos', label: 'Incautos y recuperaciones', default: false, companytypes:['vehicular','empeno','compraventa','inmobiliario','otroproducto'] },
 //       { key: 'documentos_legales', label: 'Documentos legales', default: false,companytypes:['consumo','comercial','vehicular','empeno','compraventa','inmobiliario','otroproducto'] },
   //   ]
    //}
];

//PASO 3
export const catInventarioCamposObligatorios = [
    { id: 'id', name: 'id',alias:'',prefijo:'', type: 'texto', required: true, deletelable: false, options: [], inputValue: '' },
    { id: 'costo', name: 'Costo',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
    { id: 'precio_venta', name: 'Precio de venta',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
    { id: 'precio_xmayor', name: 'Precio x Mayor',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
]

export const catInventarioGenericoCamposObligatorios = [
  { id: 'nombre', name: 'Nombre',alias:'',prefijo:'', type: 'texto', required: true, deletelable: false, options: [], inputValue: '' },
  { id: 'costo', name: 'Costo',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
  { id: 'precio_venta', name: 'Precio de venta',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
  { id: 'precio_min', name: 'Precio Minimo',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
  { id: 'precio_xmayor', name: 'Precio x Mayor',alias:'',prefijo:'', type: 'monto', required: true, deletelable: false, options: [], inputValue: '' },
  { id: 'cantidad', name: 'Cantidad',alias:'',prefijo:'', type: 'numero', required: true, deletelable: false, options: [], inputValue: '' },
]

//PASO 5

export const tiposDeProductosFinancieros = [{
    "value": "credito_personal",
    "label": "Crédito Personal",
    "description": "Préstamo destinado a cubrir necesidades personales sin garantía específica.",
  },
  {
    "value": "credito_consumo",
    "label": "Crédito de Consumo",
    "description": "Financiamiento para adquirir bienes como electrodomésticos o cubrir gastos generales."
  },
  {
    "value": "credito_educativo",
    "label": "Crédito Educativo",
    "description": "Préstamo para financiar estudios académicos o cursos de formación."
  },
  {
    "value": "credito_hipotecario",
    "label": "Crédito Hipotecario",
    "description": "Financiamiento a largo plazo para compra o construcción de vivienda, garantizado por hipoteca."
  },
  {
    "value": "credito_vehicular",
    "label": "Crédito Vehicular",
    "description": "Préstamo para adquirir automóviles, motocicletas u otros vehículos."
  },
  {
    "value": "credito_vivienda",
    "label": "Crédito para Vivienda",
    "description": "Financiamiento para remodelación, ampliación o mejora de inmuebles residenciales."
  },
  {
    "value": "credito_agropecuario",
    "label": "Crédito Agropecuario",
    "description": "Crédito destinado a actividades agrícolas o ganaderas, incluyendo insumos y maquinaria."
  },
  {
    "value": "credito_empresarial",
    "label": "Crédito Empresarial",
    "description": "Préstamo para financiar capital de trabajo, maquinaria o expansión de negocios."
  },
  {
    "value": "credito_garantia",
    "label": "Crédito con Garantía",
    "description": "Préstamo garantizado por un bien."
  }
]

export const categoriasCamposProductosFinan = [
    { id: 1, name: "Datos personales", deletelable: false },
    { id: 3, name: "Datos del préstamo", deletelable: false },
]

export const tiposDeMora = [
  { value: 'fija', label: 'Mora fija' },
//  { value: 'por_dias', label: 'Mora por días' },
//  { value: 'sobre_capital_vencido', label: 'Sobre capital vencido' },
 // { value: 'sobre_interes_vencido', label: 'Sobre interés vencido' }
]

export const tiposDeInteres = [
  { value: 'fija', label: 'Tasa fija' },
  { value:'plazo_indefinido', label: 'Plazo indefinido' },
  { value:'insoluto', label: 'Interés insoluto' },
//  { value: 'variable', label: 'Tasa variable o adjustable' },
 // { value: 'compuesto', label: 'Interés compuesto' },
  //{ value: 'anticipado', label: 'Interés anticipado' },
 // { value: 'a_vencimiento', label: 'Interés a vencimiento' },
  //{ value: 'simple', label: 'Interés simple' },
]

export const camposProductosFinancieros = [
  {"id": 2, "name": "Cédula / Identificación", "type": "ID", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
  {"id": 1, "name": "Nombre completo", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
  {"id": 3, "name": "Fecha de nacimiento", "type": "fecha", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
  {"id": 4, "name": "Estado civil", "type": "opciones", "options": ["Soltero", "Casado", "Divorciado", "Viudo"], "category": "Datos personales", "required": true}, 
  {"id": 1753886767728, "name": "Celular", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": false}, 
  {"id": 5, "name": "Teléfono", "type": "numerotel", "options": [], "category": "Datos personales", "required": true, "deletelable": true}, 
  {"id": 6, "name": "Dirección residencial", "type": "texto", "options": [], "category": "Datos personales", "required": true, "deletelable": false},
  {"id": 10, "name": "Monto solicitado", "type": "monto", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
  {"id": 12, "name": "Frecuencia de pago", "type": "opciones", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
  {"id": 11, "name": "Plazo del préstamo ", "type": "numero", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false}, 
  {"id": 13, "name": "Interes", "type": "numero", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false},
  {"id": 14, "name": "Mora", "type": "numero", "options": [], "category": "Datos del préstamo", "required": true, "deletelable": false},
]


//GENERAL
export const tiposCampos = [
    { value: 'texto', label: 'Texto' },
    { value: 'ID', label: 'ID' },
    { value: 'numero', label: 'Número' },
    { value: 'numerotel', label: 'Número Tel' },
    { value: 'monto', label: 'Monto' },
    { value: 'fecha', label: 'Fecha' },
    { value: 'opciones', label: 'Opciones' },
    { value: 'booleano', label: 'Booleano' },
];

//GARANTIAS
export const categoriasGarantia = [
  { label: "Vehículo", value: "vehiculo" },
  { label: "Inmueble", value: "inmueble" },
  { label: "Prendas", value: "prendas" },
  { label: "Otro", value: "otro" },
]

export const camposGarantia = [
{value: "vehiculo", campos: [{id:"id",name:"Chasis",type:"texto",options:[],category:"Vehículo",required:true,deletelable:false,},{id:"modelo",name:"Modelo",type:"texto",options:[],category:"Vehículo",required:true,deletelable:false,},{id:"marca",name:"Marca",type:"texto",options:[],category:"Vehículo",required:true,deletelable:false,},{id:"color",name:"Color",type:"texto",options:[],category:"Vehículo",required:true,deletelable:false,},{id:"placas",name:"Placas",type:"texto",options:[],category:"Vehículo",required:true,deletelable:false,}]},
{value: "inmueble", campos: [{id:"descrip",name:"Descripción",type:"texto",options:[],category:"Inmueble",required:true,deletelable:false},{id:"ubicacion",name:"Ubicación",type:"texto",options:[],category:"Inmueble",required:true,deletelable:false},{id:"valor",name:"Valor",type:"monto",options:[],category:"Inmueble",required:true,deletelable:false}]},
{value: "prendas", campos: [{id:"descrip",name:"Descripción",type:"texto",options:[],category:"Prendas",required:true,deletelable:false},{id:"valor",name:"Valor",type:"monto",options:[],category:"Prendas",required:true,deletelable:false}]},
{value: "otro", campos: [{id:"descrip",name:"Descripción",type:"texto",options:[],category:"Otro",required:true,deletelable:false},{id:"valor",name:"Valor",type:"monto",options:[],category:"Otro",required:true,deletelable:false}]}]